var path = 'app/scripts/modules/core/src/instance/details/instanceLinks.component.html';
var html = "<collapsible-section ng-repeat=\"section in $ctrl.sections\" heading=\"{{section.title}}\" ng-if=\"section.links.length\">\n  <ul>\n    <li ng-repeat=\"link in section.links\">\n      <a href=\"{{link.url}}\" target=\"_blank\">{{link.title}}</a>\n    </li>\n  </ul>\n</collapsible-section>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/instance/details/instanceLinks.component.html
// module id = 1097
// module chunks = 0